<!-- Home Banner -->
<section class="section section-search" style="padding-top: 0px;padding-bottom: 0px;">
	<div class="container-fluid p-0">
		<div class="banner-wrapper">
			 <div class="row" style=" margin-left: 150px;margin-right: 150px;">
				<div class="col-12 col-md-6 col-lg-6">
					<div class="banner-header">
						<!-- <p>Welcome to</p> -->
						<!-- <h1 style="color: #76c04d; padding-top: 193px;">Get connected on the go</h1> -->
						<!-- <h5 class="text-danger">want some help?</h5>
						<h5 class="text-danger">have you some unanswered question?</h5>
						<p style="margin-bottom: 0px;">Feel free to post and get answer from</p>
						<p>different mentors</p> -->
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-6" style="position: absolute;left: -308px;top: 320px;">
					<div class="float-md-right">
						<button class="btn btn-primary" style="padding-left: 17px;height: 50px;width: 183px;" routerLink="/guest/question">Post a Question <i class="fa fa-question"></i></button>
						<!-- <p>*As a Guest</p> -->
					</div>
				</div>
			</div> 
			
		</div>
	</div>
</section>
<!-- <img src="../../assets/img/image.png"> -->
<!-- /Home Banner -->
<section class="section section-specialities">
	<div class="container-fluid">
		<div class="section-header text-center">
			<h2>Specialities</h2>
			<!-- <p class="sub-title">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
				incididunt ut labore et dolore magna aliqua.</p> -->
		</div>
		
		<div class="row">
			<div class="col-md-1" ></div>
			<div class="col-md-10">
			  <div class="row justify-content-center">
				<div class="col-md-12" style="margin-left: 108px;">
					<!-- Slider -->
					<div class="specialities-slider slider slick-initialized slick-slider slick-dotted">
						<div class="slick-list draggable">
							<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)"
							(breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
							<div ngxSlickItem *ngFor="let slide of slides" class="slide">
								<div  class="slick-slide slick-current slick-active" data-slick-index="1" aria-hidden="false"
									role="tabpanel" id="slick-slide00" >
									<div>
										<div class="speicality-item text-center"
											style="width: 100%; display: inline-block;">
											<div class="speicality-img">
													<img src="{{ slide.img }}"  class="img-fluid" style="padding: 10px;" alt="" >
												<span><i class="fa fa-circle" aria-hidden="true"></i></span>
											</div>
											<p>{{slide.name}}</p>
										</div>
									</div>
								</div>
							</div>
						</ngx-slick-carousel>
						</div>
					</div>
					<!-- /Slider -->
			
				</div>
			</div>
			</div>
			<div class="col-md-1" ></div>
			</div>
	</div>
</section>


<section class="section section-features" style="padding-bottom: 0px;padding-top: 0px;">
	<div class="container-fluid" style="padding-right: 0px;padding-left: 0px">
		<div class="row">
			<div class="col-md-12 features-img">
				<img src="../../assets/img/Banner/Banner6.jpeg" class="img-fluid" alt="Feature">
			</div>
			<!-- <div class="col-md-12 features-img">
				<img src="../../assets/img/Banner/Banner1.jpg" class="img-fluid" alt="Feature">
			</div> -->
		</div>
	</div>
</section>




